import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {jwtDecode} from 'jwt-decode';
import BASE_URL from '../../../config/config';
import { Link } from 'react-router-dom';
import { FiCode, FiPenTool, FiTrendingUp, FiFolder, FiCheckCircle, FiClock, FiFolderPlus, FiAlertTriangle } from 'react-icons/fi';
import Loader from '../../../components/Loader';

const TIPO_INFO = {
  diseno: { label: 'Diseño gráfico', icon: FiPenTool },
  marketing: { label: 'Marketing/SEO', icon: FiTrendingUp },
  desarrollo: { label: 'Desarrollo web', icon: FiCode },
};

const UserProyectos = () => {
  const [proyectos, setProyectos] = useState([]);
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  const token = localStorage.getItem("AuthToken");
  let tokenInfo = {};
  if (token) {
    tokenInfo = jwtDecode(token);
  }

  useEffect(() => {
    if (!tokenInfo.usuario) return;
    axios.get(`${BASE_URL}/proyectos/usuario/${tokenInfo.usuario}`)
      .then(response => {
        if (response.data && response.data.proyectos) {
          setProyectos(response.data.proyectos);
        }
      })
      .catch(err => {
        // El backend devuelve 404 cuando el usuario simplemente no tiene proyectos:
        // no es un error real, solo lista vacía.
        if (err.response?.status === 404) {
          setProyectos([]);
        } else {
          console.error('Error al cargar los proyectos:', err);
          setError('No se pudieron cargar tus proyectos. Inténtalo de nuevo más tarde.');
        }
      })
      .finally(() => setIsLoading(false));
  }, [tokenInfo.usuario]);

  if (isLoading) return <div className="loader-fullscreen"><Loader /></div>;

  return (
    <main className='site-width'>
      <div className="user-proyectos">
        <h2>Mis proyectos</h2>
        <p>Revisa los proyectos que tengas en curso.</p>

        {error ? (
          <div className="proy-estado-card proy-estado-card--error">
            <FiAlertTriangle />
            <p>{error}</p>
          </div>
        ) : proyectos.length > 0 ? (
          <div className='grid-user-proyectos'>
            {proyectos.map(proyecto => {
              const tipoInfo = TIPO_INFO[proyecto.tipo_de_proyecto] || { label: 'No especificado', icon: FiFolder };
              const TipoIcon = tipoInfo.icon;
              // La comprobación final llega a "aceptado" cuando el proyecto queda validado y cerrado.
              const terminado = proyecto.comprobacion_final === 'aceptado';
              return (
                <Link className='item-user-proyectos' to={`/dashboard/proyecto/${proyecto.id}`} key={proyecto.id}>
                  <div className="proy-card-icon"><TipoIcon /></div>
                  <div className="proy-card-body">
                    <h3>{proyecto.nombre}</h3>
                    <span className="proy-card-tipo">{tipoInfo.label}</span>
                  </div>
                  <span className={`proy-card-badge ${terminado ? 'terminado' : 'progreso'}`}>
                    {terminado ? <FiCheckCircle /> : <FiClock />}
                    {terminado ? 'Terminado' : 'En progreso'}
                  </span>
                </Link>
              );
            })}
          </div>
        ) : (
          <div className="proy-estado-card">
            <FiFolderPlus />
            <p>Actualmente no tienes ningún proyecto en curso o finalizado.</p>
            <span>Cuando tengamos un proyecto en marcha contigo, aparecerá aquí.</span>
          </div>
        )}
      </div>
    </main>
  );
};

export default UserProyectos;
